export default __webpack_public_path__ + "files/04040dc3b0c053461c02444a0df0be60.jpg";